import * as React from 'react'
import styled from 'styled-components'
import { Style } from '../../styles'

export default styled.div`
	height: 1px;
	background-color: ${Style.color.border};
	margin: 10px 15px;
`